"use strict";
/* globals module */
/**
 * @module notificationsRoute
 * @description Baasic Notifications Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
var contracts_1 = require("../../core/contracts");
var _1 = require("./");
var NotificationsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsRoute, _super);
    function NotificationsRoute(appOptions, notificationsPublishRoute, basicNotificationsSubscriptionsRoute, notificationsRegistrationsRoute, notificationsSettingsRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.notificationsPublishRoute = notificationsPublishRoute;
        _this.basicNotificationsSubscriptionsRoute = basicNotificationsSubscriptionsRoute;
        _this.notificationsRegistrationsRoute = notificationsRegistrationsRoute;
        _this.notificationsSettingsRoute = notificationsSettingsRoute;
        return _this;
    }
    Object.defineProperty(NotificationsRoute.prototype, "publish", {
        get: function () {
            return this.notificationsPublishRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsRoute.prototype, "subscriptions", {
        get: function () {
            return this.basicNotificationsSubscriptionsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsRoute.prototype, "registrations", {
        get: function () {
            return this.notificationsRegistrationsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsRoute.prototype, "settings", {
        get: function () {
            return this.notificationsSettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    var _a, _b, _c, _d, _e;
    NotificationsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsPublishRoute)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsRoute)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.NotificationsRegistrationsRoute)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.NotificationsSettingsRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsPublishRoute !== "undefined" && _1.NotificationsPublishRoute) === "function" ? _b : Object, typeof (_c = typeof _1.NotificationsSubscriptionsRoute !== "undefined" && _1.NotificationsSubscriptionsRoute) === "function" ? _c : Object, typeof (_d = typeof _1.NotificationsRegistrationsRoute !== "undefined" && _1.NotificationsRegistrationsRoute) === "function" ? _d : Object, typeof (_e = typeof _1.NotificationsSettingsRoute !== "undefined" && _1.NotificationsSettingsRoute) === "function" ? _e : Object])
    ], NotificationsRoute);
    return NotificationsRoute;
}(common_1.BaseRoute));
exports.NotificationsRoute = NotificationsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
